import { Duration } from '../types';
import Select from './Select';
import { Option } from './styled';

interface TargetPriceSelectProps {
  duration: Duration;
  onChangeDuration: (val: any) => any;
}

function TargetPriceSelect({ duration, onChangeDuration }: TargetPriceSelectProps) {
  const handleChange = (e) => {
    const data = {
      target_duration: e.target.value,
    };
    onChangeDuration(data);
  };
  return (
    <Select
      label="within"
      value={duration}
      selectRef={() => {}}
      onChange={handleChange}
    >
      <Option value="7">1 Week</Option>
      <Option value="30">1 Month</Option>
      <Option value="90">3 Months</Option>
      <Option value="180">6 Months</Option>
      <Option value="365">1 year</Option>
      <Option value="730">2 years</Option>
      <Option value="1095">3 years</Option>
    </Select>
  );
}

export default TargetPriceSelect;
